import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "expendedurias-view py-3" }

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useEntitiesStore } from '@/stores/useEntitiesStore'
import ExpendeduriaListComponent from '@/components/expendedurias/ExpendeduriaListComponent.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExpendeduriasView',
  setup(__props) {

const router = useRouter()
const store = useEntitiesStore()

// Control del modal de creación de Expendeduría
const showCreateModal = ref(false)

// Abrir el modal de creación
const handleOpenCreateModal = () => {
  showCreateModal.value = true
}

// Redirigir al detalle/máquinas cuando se selecciona un estanco de la lista
const handleSelectExpendeduria = (id: number) => {
  router.push({ name: 'expendeduria-detail', params: { id } })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ExpendeduriaListComponent, {
      onCreate: handleOpenCreateModal,
      onSelectExpendeduria: handleSelectExpendeduria
    })
  ]))
}
}

})